<template>
    <section class="index">
    <div class="container" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
			<div class="gc-page-container">
      	<div class="container-center">
          <div style="width: 100%;display: flex;align-items: center;justify-content: space-between;margin: 20px 0px;padding: 0 10px;">
            <div class="shuomin">渠道ID：{{ cid }}</div>
            <div style="display: flex;">
              <el-date-picker
                v-model="selectDate"
                type="daterange"
                size="small"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="onSelectDateChange">
              </el-date-picker>
              <button @click="onCancel" class="cancel-btn" v-if="selectDate && selectDate.length > 0">取消</button>
              <button @click="onDownload" class="download-btn" v-if="selectDate && selectDate.length > 0 && list && list.length > 0">下载</button>
            </div>
          </div>
          <section class="gc-page-tmp" @click="onBack" style="cursor: pointer;display: flex;align-items: center;justify-content: center;">
            <!-- <div class="top-bg">
              <div class="top-bottom">
              </div>
              <div class="top-point">{{ info ? info.cmoney : 0 }}<span>元</span></div>
            </div>
            <div class="top-row">
              <div class="top-row-title">奖励明细</div>
              <div class="top-row-detail">
                <svg t="1671162062181" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2676" width="14" height="14"><path d="M761.6 489.6l-432-435.2c-9.6-9.6-25.6-9.6-35.2 0-9.6 9.6-9.6 25.6 0 35.2l416 416-416 425.6c-9.6 9.6-9.6 25.6 0 35.2s25.6 9.6 35.2 0l432-441.6C771.2 515.2 771.2 499.2 761.6 489.6z" p-id="2677"></path></svg>
              </div>
            </div>
            <div class="top-row">
              <div class="top-row-title">已绑定微信</div>
              <div class="top-row-detail">{{ info ? info.manageNickname : '' }}</div>
            </div>
            <a href="javascript:void(0)" class="bg-btn zhuan" @click="onTapTixian">转入微信零钱</a>
            <p class="top-notice">满500元可申请提现</p> -->
            <svg t="1672798407858" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2836" width="128" height="128"><path d="M512 64C264.8 64 64 264.8 64 512s200.8 448 448 448 448-200.8 448-448S759.2 64 512 64z m0 832c-212 0-384-172-384-384s172-384 384-384 384 172 384 384-172 384-384 384z m158.4-610.4L444 512l226.4 226.4-44.8 45.6-272-272 272-272 44.8 45.6z" p-id="2837" fill="#888888"></path></svg>
          </section>

          <!-- 点子动态 -->
          <section class="gc-page" v-for="(item,index) in list" :key="index">
              <div class="gc-headImg-ctx">
                <img class="gc-headImg" src="../assets/img/zhangdan@2x.png" />
              </div>
              <div class="gc-page-top done" style="display: flex;justify-content: center;align-items: center;">
                <p class="gc-money-big">{{ item.paytype === 0 ? '+' : '-'}}{{ item.money }}</p>
              </div>
              <div class="gc-page-center">
                <p class="gc-nickname">{{ item.nickName }}</p>
                <p class="gc-title" v-if="item.paytype === 0">[{{ item.ssiprid }}]</p>
                <!-- <p class="gc-subtitle">{{ item.paytype === 0 ? '奖励' : '提现'}}{{ item.money }}元</p> -->
                <template v-if="item.paytype === 1">
                  <p class="gc-subtitle" v-if="item.status === 0">提现中</p>
                  <template v-else-if="item.status === 1">
                    <p class="gc-subtitle">奖励金已转入微信零钱</p>
                    <p class="gc-subtitle">交易号：{{ item.orderNo }}</p>
                  </template>
                </template>
              </div>
              <div class="gc-qrtime">创建时间：{{item.addtime}}</div>
          </section>
				</div>
      </div>
    </div>

    <!-- 提现不够 -->
    <div class="noEnoughWin" v-if="isShowNoTixianDialog">
			<div>
				<h4>你尚没有足够奖励可转入微信零钱</h4>
				<p>满500元可申请提现</p>
				<a @click="isShowNoTixianDialog = false">知道了</a>
			</div>
		</div>

    <!-- 仅限管理员提现 -->
    <div class="noEnoughWin" v-if="isShowJustAdmin">
			<div>
				<h4>仅限渠道管理员操作</h4>
				<a @click="isShowJustAdmin = false">知道了</a>
			</div>
		</div>

    <!-- 提现输入 -->
    <!-- 提现弹窗 -->
		<div class="importWin" v-if="isShowTixianDialog">
			<div class="point">
				<div class="importWin-top-div">
					<img class="close left">
					<h4>奖励转微信零钱</h4>
					<img src="../assets/img/close-area.png" class="close right" 
          @click="closeTixianDialog">
				</div>
				
				<div class="my-idea">
					<div class="my-idea-t">我的奖励：</div>
					<div class="dot">
						<div class="idea">{{ info.cmoney }}</div>
						<div class="dot-dot">元</div>
					</div>
				</div>
				<div class="my-idea-y">
					<div class="my-idea-t">请输入需要转入奖励</div>
					<div class="money">元</div>
				</div>
				<div class="tmp-dianzi">
					<input type="text" id='inputPoint' placeholder="0" v-model="inputMoney"/>
					<div class="input-under">元</div>
				</div>
				<div class="sec-err" v-if="errAlertTxt">{{errAlertTxt}}</div>
				<div class="button" @click="onTapTixianConfirm">确认</div>
			</div>
		</div>
  </section>
</template>

<script>
import { getCookie } from '../utils';

export default {
  data() {
    return {
      cid: '',
      isAdmin: false,
      unionId: '',
      list: [],
      pageNum: 1,
      pages: 0,
      info: null,

      isShowNoTixianDialog: false,
      isShowTixianDialog: false,
      errAlertTxt: '',
      inputMoney: '',
      isShowJustAdmin: false,

      filterNum: 1,
      filterPages: 0,
      selectDate: '',
      filterList: [],

      // pickerOptions: {
      //   onPick(time) {
      //     // 如果选择了只选择了一个时间
      //     if (!time.maxDate) {
      //       let timeRange = 30 * 24 * 60 * 60 * 1000 // 30天
      //       _minTime = time.minDate.getTime() - timeRange // 最小时间
      //       _maxTime = time.minDate.getTime() + timeRange // 最大时间
      //       // 如果选了两个时间，那就清空本次范围判断数据，以备重选
      //     } else {
      //       _minTime = _maxTime = null
      //     }
      //   },
      //   disabledDate(time) {
      //     // onPick后触发
      //     // 返回false表示该日期禁选
      //     if (_minTime && _maxTime) {
      //       return time.getTime() < _minTime || time.getTime() > _maxTime
      //     }
      //   }
      // },
    }
  },
  mounted() {
    // this.cid = getCookie('cid')
    // this.unionId = getCookie('unionId')
    // if (!this.cid || this.cid.length == 0) {
      
    // } else {
    //   this.getList()
    //   this.getInfoData()
    // }

    this.unionId = getCookie('unionId')
    this.checkChannel()
  },

  methods: {
    // 判断是否显示 渠道回答
    async checkChannel() {
      const res = await this.$axios.get(`https://home.51point.com/51point-0.0.1-SNAPSHOT/channel/gc?param=${this.unionId}`)
      if (res.data.code == 1) {
        this.cid = res.data.data.cid
        this.isAdmin = res.data.data.isF == 1
        this.getList()
        this.getInfoData()
      }
    },


    async getList() {
      let url = `https://home.51point.com/51point-0.0.1-SNAPSHOT/channel/gpl?cid=${this.cid}&u=${this.unionId}&pageNum=${this.pageNum}&pageSize=10`
      if (this.selectDate && this.selectDate.length == 2) {
        url += `&ds=${this.selectDate[0]}&de=${this.selectDate[1]}`
      }
      const res = await this.$axios.get(url)
      if (res.data.code == 1) {
        this.pages = res.data.pages
        this.list = res.data.data
      }
    },

    async getInfoData() {
      const res = await this.$axios.get(`https://home.51point.com/51point-0.0.1-SNAPSHOT/channel/gm?cid=${this.cid}&u=${this.unionId}`)
      if (res.data.code == 1) {
        this.info = res.data.data
      }
    },

    // 提现
    async onTapTixian() {
      if (this.isAdmin) {
        // 管理员
        if (this.info.cmoney < 500) {
          this.isShowNoTixianDialog = true
          return
        }
        this.isShowTixianDialog = true
      } else {
        // 非管理员
        this.isShowJustAdmin = true
      }
    },

    // 确认提现
    async onTapTixianConfirm() {
      if (this.inputMoney.length == 0) {
				// 没有输入
				this.errAlertTxt = '请输入要转入的奖励金额'
				return
			}
      const input = parseInt(this.inputMoney)
      if (isNaN(input)) {
        this.errAlertTxt = '输入的金额不合法，请输入大于0的数字'
				return
      }
			if (!input || input <= 0) {
				this.errAlertTxt = '输入的金额不合法，请输入大于0的数字'
				return
			}
			if (input > this.info.cmoney) {
				this.errAlertTxt = '输入的点子数超过了可以提现的点子数'
				return
			}
			if (input < 500) {
				this.errAlertTxt = '每次提现金额不能少于 500 点'
				return
			}

      const res = await this.$axios.get(`https://home.51point.com/51point-0.0.1-SNAPSHOT/channel/ap?cid=${this.cid}&u=${this.unionId}&m=${this.inputMoney}`)
      if (res.data.code == 1) {
        this.$message.success('提现成功')
        this.getList()
        this.getInfoData()
        this.isShowTixianDialog = false
        this.inputMoney = ''
        this.errAlertTxt = ''
      } else {
        this.$message.error('提现失败，请稍后重试')
      }
    },

    closeTixianDialog() {
      this.isShowTixianDialog = false
      this.errAlertTxt = ''
    },

    onBack() {
      window.history.back()
    },

    loadMore() {
      console.log('--- loadMore')
      if (this.pageNum < this.pages) {
        this.pageNum++
        this.getList()
      }
    },

    onSelectDateChange() {
      console.log('--- onSelectDateChange')
      console.log(this.selectDate)
      this.pageNum = 1
      this.getList()
    },

    async onDownload() {
      const a = document.createElement('a');
      a.setAttribute('href', `https://home.51point.com/51point-0.0.1-SNAPSHOT/channel/ex?cid=${this.cid}&ds=${this.selectDate[0]}&de=${this.selectDate[1]}`);
      a.setAttribute('download', `${this.selectDate[0]}-${this.selectDate[1]}回答记录.xlsx`);
      a.click();
    },

    onCancel() {
      this.selectDate = ''
      this.pageNum = 1
      this.getList()
    },
  }
}
</script>

<style scoped>

.index .gc-qrcode-img{
  width:125px;
  height:125px;
  margin: 20px auto;
}
.index .wxssk{
  font-size: 12px;
  color: #666666;
  text-align: center;
}
.index .gc-qrcode-ctx{
  width: 160px;
  height: 200px;
  background: #FFFFFF;
  border: 1px solid #EFEFEF;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,0.08);
  border-radius: 2px;
}
.index .gc-qrcode{
  position: absolute;
  bottom: 20px;
  right: 15px;
}

.index .gc-qrtime {
  position: absolute;
  bottom: 20px;
  left: 15px;
  font-size: 10px;
  color: #999;
}
.index .gc-qrcode-text{
  font-size: 13px;
  color: #959499;
  border: 1px solid #d8d8d8;
  border-radius: 2px;
  /* width: 60px; */
  padding-left: 10px;
  padding-right: 10px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  float: right;
  margin-top: 10px;
  cursor: pointer;
}
.index .gc-qrcode-text:hover{
  background: #C9C9CE;
  border-color: #C9C9CE;
  color: #fff;
}
.index .gc-page{
  float:left;
  /* margin-right: 20px; */
  margin-left: 10px;
  margin-right: 10px;
}
.index .gc-category{
  position: absolute;
  right: 15px;
  top:15px;
  z-index: 2;
  border-radius: 100px;
  background-color: rgba(0,0,0,.7);
  font-size: 11px;
  color: #FFFFFF;
  padding:5px;
}
.index .gc-page-bottom{
  position: absolute;
  bottom: 20px;
  z-index: 2;
  left: 15px;
  height: 16px;
  line-height: 16px;
  width: 150px;
  font-size: 12px;
  color: #9B9B9B;
}
.index .gc-headImg-ctx{
  position: absolute;
  top: 125px;
  left: 15px;
  z-index: 2;
  width:32px;
  height:32px;
}
.index .gc-headImg{
  width:32px;
  height:32px;
  border-radius: 32px;
  border: 2px solid #FFFFFF;
}
/* .index .gc-page-top{
  width: 280px;
  height: 140px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
} */
.index .gc-page-top{
  width: 280px;
  height: 140px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  /* justify-content: center; */
  justify-content: flex-end;
}
.index .gc-page-center{
  position: relative;
  padding:15px;
  padding-top: 25px;
}
.index .gc-nickname{
  font-size: 13px;
  color: #666666;
  margin-bottom: 15px;
}
.index .gc-title{
  font-size: 15px;
  color: #333;
  margin-bottom: 12px;
  line-height: 22px;
}
.index .gc-subtitle{
  font-size: 12px;
  color: #888888;
  line-height: 18px;
  /* max-height: 54px; */
  overflow: hidden;
  word-break: break-all;
}
.index .gc-page{
  width: 280px;
  height: 360px;
  background: #FFFFFF;
  /* cursor: pointer; */
  position: relative;
  margin-bottom: 20px;
}
.index .gc-page:hover{
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.08);
}
.index .container {
  min-height: 540px;
}
.index .gc-page-top img {
  width: 100%;
  height: 100%;
  background: gray;
}

.noQ {
	display: block;
	padding-top: 20px;
}

.noQ p {
	font-size: 14px;
	color: #666;
	text-align: center;
	line-height: 28px;
}

.noQ-div {
	width: 260px;
	height: 196.48px;
	margin: 0 auto;
	background-size: 360px 196.48px;
	padding-top: 22px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.noQ .noQ-link {
	color: #65AE71;
	border-bottom: 3px double #65AE71;
}

.noQ-btn {
	font-size: 16px;
	margin-top: 10px;
	color: white;
	/* background: #DF7F7D; */
	background:#65AE71;
	height: 40px;
	width: 120px;
	border-radius: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
  cursor: pointer;
}

.noQ div:nth-of-type(2) {
	width: 47px;
	height: 77px;
	margin: 10px auto 0;
	background: url(../assets/img/zhanwuicon@2x.png) center no-repeat;
	background-size: 47px 77px;
}
.done {
  background: #9FC2E2;
}

.ing {
  background: #D4B7B5;
}

/* .done-status {
  position: relative;
  left: 110px;
  top: 118px;
  color: white;
} */

.ing-status {
  position: relative;
  left: 115px;
  top:  110px;
  color: white;
}

.ing-status span {
  font-size: 160%;
  margin-right: 4px;
}


/*  */
.shuomin {
  color: #999;
  font-size: 14px;
  margin: 20px 0px;
  padding-left: 10px;
  width: calc(100% - 10px);
}

.gc-page-container {
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin: 0 auto;
}

.index .container-center{
  margin:0 auto;
  overflow: hidden;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: flex-start;
}

/* 手机 */
@media screen and (max-width: 768px) {
	.index .container-center {
		width: 300px;
	}
}

/* Pad */
@media screen and (min-width: 768px) and (max-width: 1023px) {
	.index .container-center {
		width: 600px;
	}
}

/* 中屏幕电脑 */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
	.index .container-center {
		width: 900px;
	}
}

/* 大屏幕电脑 */
@media screen and (min-width: 1200px) {
	.index .container-center {
		width: 1200px;
	}
}

.done-status {
  /* position: relative;
  left: 105px;
  top: 8px; */
    /* width: 280px;
  height: 360px; */
  color: white;
  display: flex;
  flex-direction: row-reverse;
  margin-right: 5px;
  margin-bottom: 5px;
}

.gc-money {
  color: white;
  font-size: 80px;
  text-align: center;
  margin-bottom: -10px;
  /* font-weight: 545; */
}

.gc-money-big {
  color: #E3696A;
  font-size: 65px;
  text-align: center;
}

.gc-money span {
  font-size: 20px;
  margin-left: 5px;
  /* font-weight: normal; */
}

.index .gc-page-tmp{
  /* float:left; */
	margin-left: 10px;
	margin-right: 10px;
  width: 280px;
  height: 360px;
  background: #FFFFFF;
  /* cursor: pointer; */
  position: relative;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.index .gc-page-tmp:hover{
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.08);
}

.top-point {
  font-size: 48px;
  color: white;
  margin-bottom: 30px;
}

.top-point span {
  font-size: 15px;
  margin-left: 5px;
}

.top-title {
    font-size: 14px;
    color: #fff;
    margin-left: 10px;
}

.top-title span {
    opacity: .5;
    font-size: 12px;
    margin-left: 10px;
    color: #fff;
}

.top-bottom {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
}

.top-bottom img {
  height: 18px;
  width: 18px;
  margin-right: 10px;
}

.top-notice {
    font-size: 14px;
    color: #999;
    text-align: center;
    margin-top: 10px;
}

.top-bg {
  height: 40%;
  width: 100%;
  background: #E3696A;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.bg-btn {
  width: 90%;
  height: 45px;
  color: white;
  display: block;
  border-radius: 4px;
  font-size: 15px;
  line-height: 45px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.zhuan {
  background: #E3696A;
}

.exit {
  background: #f16754;
}

.top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #EBEEF5;
  padding: 12px 8px;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
}

.top-row-title {
  font-size: 14px;
  color: #333;
}

.top-row-detail {
  font-size: 12px;
  color: #999;
}

/*点子不足*/
.noEnoughWin {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1000;
	background: rgba(0, 0, 0, 0.5);
	padding: 10px 2px 0;
}

.noEnoughWin div {
  width: 20%;
  margin: 10% auto 0 auto;
	background: #fff;
	border-radius: 4px;
  padding: 18px 45px 26px;
  -webkit-animation: fadeInDown .3s;
  animation: fadeInDown .3s;
}

.noEnoughWin div h4 {
	font-size: 15px;
	color: #333;
	text-align: center;
	margin-bottom: 16px;
}

.noEnoughWin div p {
	font-size: 14px;
	color: #999;
	text-align: center;
	margin-bottom: 20px;
}

.noEnoughWin div a {
	display: block;
	font-size: 14px;
	text-align: center;
	color: #fff;
	background: #E3696A;
	border-radius: 8px;
  line-height: 44px;
  cursor: pointer;
}

@keyframes fadeInDown {
    0% {
        -webkit-transform: translate3d(0, -20%, 0);
        -webkit-transform: translate3d(0, -20%, 0);
        transform: translate3d(0, -20%, 0);
        transform: translate3d(0, -20%, 0);
        opacity: 0;
    }
    100% {
        -webkit-transform: none;
        transform: none;
        opacity: 1;
    }
}

/*提现输入电子数*/
.importWin {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1000;
	padding: 61px 20px 0;
	background: rgba(0, 0, 0, 0.5);
	border-radius: 4px;
}

.importWin-top-div {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
  margin-bottom: 20px;
}

.close {
	width: 14px;
	height: 14px;
	border: 0;
}

.left {
	opacity: 0;
}

/*输入提现电子数*/
.point {
	background: #fff;
	border-radius: 4px;
  padding: 22px 20px 30px;
  /* margin: 5% 32%; */
  -webkit-animation: fadeInDown .3s;
  animation: fadeInDown .3s;
  width: 20%;
  margin: 10% auto 0 auto;
}

.point h4 {
	font-size: 18px;
	color: #333;
	text-align: center;
}

.point p:nth-of-type(1) {
	font-size: 14px;
	color: #333;
	margin-bottom: 21px;
}

.my-idea {
	font-size: 14px;
	color: #333;
	margin-bottom: 21px;
	display: flex;
	flex-direction: row;
	align-items: flex-end;
}

.my-idea-y {
	font-size: 14px;
	color: #333;
	margin-bottom: 21px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.my-idea-t {
	font-size: 14px;
	color: #333;
}

.dot {
	font-size: 24px;
	color: #E3696A;
	display: flex;
	flex-direction: row;
	align-items: flex-end;
}

.dot .idea {
  margin-bottom: -2px;
}

.dot .dot-dot {
	font-size: 14px;
	margin-left: 4px;
	color: #E3696A;
}

.point p:nth-of-type(2) {
	font-size: 14px;
	color: #333;
	margin-bottom: 22px;
}

.point p:nth-of-type(2) text {
	display: inline-block;
	float: right;
	color: #E3696A;
}

.point p:nth-of-type(3) {
	border-bottom: 1px solid #ccc;
	padding-bottom: 8px;
}

.point p:nth-of-type(3) input {
	font-size: 36px;
	/* width: 28rem; */
	width: 100%;
}

.point p:nth-of-type(3) input::input-placeholder {
	color: #999;
}

.point p:nth-of-type(3) text {
	font-size: 14px;
	color: #333;
}

.point .button {
	font-size: 15px;
	color: #fff;
	background: #E3696A;
	border-radius: 8px;
	line-height: 44px;
	width: 100%;
  margin-top: 30px;
  display: flex;
  align-content: center;
  justify-content: center;
  cursor: pointer;
}

.check-btn {
	font-size: 15px;
	color: #fff;
	/* background: #65ae71; */
	background: #999;
	border-radius: 8px;
	/* line-height: 4.4rem; */
	height: 44px;
	width: 100%;
	margin-top: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.active {
	background: #65ae71; 
}

/*核对真实姓名*/
.checkName {
	padding: 19px 30px 29px;
	background: #fff;
  border-radius: 4px;
  /* margin: 5% 32%; */
    -webkit-animation: fadeInDown .3s;
  animation: fadeInDown .3s;
}

.checkName h4 {
	font-size: 16px;
	color: #333;
	margin-bottom: 20px;
	text-align: center;
}

.checkName input {
	font-size: 14px;
	/* width: 23.5rem; */
	width: 80%;
	/* height: 5rem; */
	height: 40px;
	border: 1px solid #d8d8d8;
	border-radius: 8px;
	padding-left: 10px;
	margin: 0 auto 10px;
	display: block;
}

.checkName p {
	text-align: center;
	font-size: 14px;
	line-height: 16px;
	color: #999;
}

.checkName .button {
	font-size: 15px;
	color: #fff;
	line-height: 44px;
	text-align: center;
	background: #65ae71;
	border-radius: 8px;
	margin-top: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

#inputPoint {
  width: calc(100% - 20px);
  height: 40px;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid #d8d8d8;
  padding: 0 10px;
}

/* WebKit browsers */
::-webkit-input-placeholder {
	color: #777;
}
/* Mozilla Firefox 4 to 18 */
:-moz-placeholder {
	color: #777;
	opacity: 1;
}
/* Mozilla Firefox 19+ */
::-moz-placeholder {
	color: #777;
	opacity: 1;
}
/* Internet Explorer 10+ */
:-ms-input-placeholder {
	color: #777;
}


.sec-err {
  background: #FEEDEE;
  color: #F46969;
  font-size: 12px;
  padding: 10px 20px;
  border-radius: 4px;
  margin-top: 20px;
}

.download-btn {
  margin-left: 10px;
  background-color: #E3696A;
  color: white;
  border: none;
  outline: none;
  border-radius: 4px;
  padding: 0 12px;
  flex-shrink: 0;
}

.cancel-btn {
  margin-left: 10px;
  background-color: transparent;
  color: #E3696A;
  border: 1px solid #E3696A;
  border-radius: 4px;
  padding: 0 12px;
  flex-shrink: 0;
}
</style>
